import React, { Component, ReactNode } from 'react'
import { Button } from 'react-bootstrap'
import i18n from 'i18n'

type Props = {
  children: ReactNode,
  resetKey?: string | number,
}

type State = {
  hasError: boolean,
  error?: Error,
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: undefined })
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined })
  }

  handleGoHome = () => {
    window.location.href = '/'
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center px-4">
          <h2 className="mb-4 text-danger">{i18n.t('common.error_boundary.title')}</h2>
          <p className="mb-4 text-muted">{i18n.t('common.error_boundary.subtitle')}</p>
          <div className="d-flex gap-2">
            <Button
              onClick={this.handleRetry}
              variant="outline-primary"
              style={{
                padding: '0.6rem 1.5rem',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 500,
              }}
            >
              {i18n.t('common.button.try_again')}
            </Button>
            <Button
              onClick={this.handleGoHome}
              style={{
                backgroundColor: '#034ea2',
                borderColor: '#034ea2',
                padding: '0.6rem 1.5rem',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 500,
              }}
            >
              {i18n.t('common.button.go_home')}
            </Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
